import join from 'url-join';

import { asyncAction, http, createAction } from '../util/';
import { encryptString } from '../util/crypto';

import { loadUser } from '../user/actions';

const api = join(import.meta.env.VITE_API_URL, 'v1');

export const resetUserValidation = createAction('RESET_USER_VALIDATION');
export const setValidationError = createAction('SET_VALIDATION_ERROR');
export const setUserResetEmail = createAction('SET_USER_RESET_EMAIL');

export const validateLegacyUser = asyncAction({
  baseName: 'VALIDATE_LEGACY_USER',
  action: action => values => dispatch => {
    const updatedValues = {
      ...values,
      password: encryptString(values.password)
    };

    dispatch(action.start(updatedValues));
    return http
      .post(join(api, 'legacy/user/validate'), updatedValues)
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error(error)));
  }
});

export const migrateUser = asyncAction({
  baseName: 'MIGRATE_USER',
  action: action => values => dispatch => {
    const updatedValues = {
      ...values,
      password: encryptString(values.password)
    };
    dispatch(action.start(updatedValues));
    return http
      .post(join(api, 'legacy/user/migrate'), updatedValues)
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error(error)));
  }
});

export const migrateAdditionalAccount = asyncAction({
  baseName: 'MIGRATE_ADDITIONAL_ACCOUNT',
  action: action => ({ username, password, newUsername }) => dispatch => {
    const updatedValues = {
      username,
      password: encryptString(password)
    };
    dispatch(action.start(updatedValues));
    return http
      .post(join(api, 'migrate/user/account'), updatedValues)
      .then(({ data: response }) => {
        dispatch(loadUser(newUsername.toLowerCase()));
        return dispatch(action.success(response));
      })
      .catch(error => dispatch(action.error(error)));
  }
});

export const legacyPasswordRecover = asyncAction({
  baseName: 'LEGACY_PASSWORD_RECOVER',
  action: action => ({ username }) => dispatch => {
    dispatch(action.start(username));

    return http
      .post(join(api, `legacy/pre-migrate/recover/password/${username}`))
      .then(({ data: response }) => {
        dispatch(setUserResetEmail(username));
        return dispatch(action.success(response));
      })
      .catch(error => dispatch(action.error(error)));
  }
});

export const legacyPasswordReset = asyncAction({
  baseName: 'LEGACY_PASSWORD_RESET',
  action: action => values => dispatch => {
    const updatedValues = {
      ...values,
      password: encryptString(values.password),
      newPassword: encryptString(values.password)
    };

    dispatch(action.start(updatedValues));

    return http
      .post(join(api, 'legacy/pre-migrate/reset/password'), updatedValues)
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error(error)));
  }
});

export const recoverUsername = asyncAction({
  baseName: 'RECOVER_USERNAME',
  action: action => ({ email }) => dispatch => {
    dispatch(action.start(email));

    return http
      .post(join(api, `legacy/recover/usernames/${email}`))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error(error)));
  }
});

export const registerInvite = asyncAction({
  baseName: 'REGISTER_INVITE',
  action: action => values => dispatch => {
    dispatch(action.start(values));
    const updatedValues = {
      ...values,
      password: encryptString(values.password)
    };

    return http
      .post(join(api, 'invite/accept'), updatedValues)
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error(error)));
  }
});

export const getIdmUser = asyncAction({
  baseName: 'FETCH_IDM_USER',
  action: action => email => dispatch => {
    dispatch(action.start());
    return http
      .get(join(api, `legacy/migrate/validate/user/idme/${email}`))
      .then(({ data: response }) => dispatch(action.success(response)))
      .catch(error => dispatch(action.error({ error })));
  }
});
